import React from 'react';

import {REMOTE_CONFIG_PATHS} from '../../../constants/remoteConfigPaths';
import {DynamicContent} from '../../DynamicContent';

export const SignalingInEstablishments = () => {
  return (
    <DynamicContent
      configPath={
        REMOTE_CONFIG_PATHS.MERCHANT_POLICY.SECTIONS.SIGNALING_ESTABLISHMENTS
      }
      renderAsHtml={true}
    />
  );
};
